import React, { useEffect, useState } from "react";
import { Languages } from "lucide-react";

export default function FloatingTranslator() {
  const [showLanguages, setShowLanguages] = useState(false);

  const languages = [
    { code: "en", name: "English" },
    { code: "fr", name: "French" },
  ];

  // Load Google Translate script only once
  useEffect(() => {
    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,fr",
            autoDisplay: false,
          },
          "google_translate_element"
        );
      };
    }
  }, []);

  const handleLanguageSelect = (langCode) => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = langCode;
      select.dispatchEvent(new Event("change"));
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg cursor-pointer hover:bg-blue-700 transition"
        onClick={() => setShowLanguages(!showLanguages)}
      >
        <Languages className="w-5 h-5 mr-2" />
        <span>Translate</span>
      </div>

      {showLanguages && (
        <div className="mt-2 bg-white shadow-lg rounded-xl p-2 max-h-60 overflow-y-auto">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer rounded-md"
              onClick={() => handleLanguageSelect(lang.code)}
            >
              {lang.name}
            </div>
          ))}
        </div>
      )}

      {/* Hidden Google Translate Element */}
      <div id="google_translate_element" style={{ display: "none" }}></div>
    </div>
  );
}
